import { FC } from 'react'
import { Modal } from 'antd'
import cn from 'classnames'
import amclasses from '@pages/Admin/CRM/styles/ammodal.module.css'
import classes from '../index.module.css'
import type { WazzupIframeModalState } from '../phoneIntegrationButtons.types'

type WazzupIframeModalProps = {
  state: WazzupIframeModalState
  onClose: () => void
}

const WazzupIframeModal: FC<WazzupIframeModalProps> = ({ state, onClose }) => (
  <Modal
    open={state.open}
    onOk={onClose}
    onCancel={onClose}
    footer={null}
    title={null}
    centered
    maskClosable
    className={cn(amclasses.modal, classes.iframeModal)}
  >
    <iframe
      title="Чат CRM-интеграции"
      src={state.iframeUrl}
      className={classes.iframe}
    />
  </Modal>
)

export default WazzupIframeModal
